import React, { useState, useEffect } from "react";
import { Grid, Button, Box } from "@mui/material";
import ReconciliationTable from "./ReconciliationTable";
import { darkenColor } from "./Utils";

const TabStatus = (props) => {
  const {
    tabStatus,
    tabCode,
    setTabCode,
    tabStatusHandler,
    header,
    data,
    backColor,
    accountName,
    navigate,
  } = props;

  const [selectedTabData, setSelectedTabData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (Array.isArray(data)) {
      const activeTab = data.find((ele) => ele.status === tabStatus);
      setSelectedTabData(activeTab?.data ?? []);
    }
  }, [tabStatus, data]);

  console.log("TabStatus Debug:", { data, tabStatus });

  return (
    <>
      <div style={{ overflowX: "auto", width: "100%" }}>
        <Box
          sx={{
            margin: "5px 0px",
            display: "flex",
            gap: "4vh",
            minWidth: "100%",
            "&::-webkit-scrollbar": {
              height: "5px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: backColor,
              borderRadius: "10px",
            },
          }}
        >
          {Array.isArray(data) &&
            data.map((ele, index) => (
              <Box key={index}>
                <Button
                  onClick={() => {
                    tabStatusHandler(ele);
                    setSelectedTabData(ele.data ?? []);
                  }}
                  variant="contained"
                  sx={{
                    padding: "0.5rem",
                    margin: "2px 0px",
                    border: "1px solid rgb(14 57 115 / 86%)",
                    color: "black",
                    height: "6vh",
                    width: "220px",
                    backgroundColor:
                      tabStatus === ele.status
                        ? "#64b264"
                        : !tabStatus || !tabCode
                        ? ele?.backgroundColor
                        : ele?.backgroundColor,

                    "&:hover": {
                      background:
                        tabStatus === ele.status
                          ? "#64b264"
                          : !tabStatus || !tabCode
                          ? darkenColor(ele?.backgroundColor, 0.1)
                          : darkenColor(ele?.backgroundColor, 0.1),
                    },
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "10px 0px",
                    }}
                  >
                    <p>{ele.data?.length ?? 0}</p>
                    <p style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                      {ele.name}
                    </p>
                  </div>
                </Button>
              </Box>
            ))}
        </Box>
      </div>
      {/* Render ReconciliationTable with selected tab data */}
      <ReconciliationTable
        headerConfig={header}
        data={selectedTabData}
        pageNo={pageNo}
        setPageNo={setPageNo}
        totalPages={totalPages}
        setTotalPages={setTotalPages}
        pageSize={pageSize}
        setPageSize={setPageSize}
        tabStatus={tabStatus}
        navigate={navigate}
      />
    </>
  );
};

export default TabStatus;
